import { ReactNode } from 'react'
import Footer from './Footer'

interface AppLayoutProps {
  children: ReactNode
  showFooter?: boolean
}

export default function AppLayout({ children, showFooter = true }: AppLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-grow">
        {children}
      </div>
      {showFooter && <Footer />}
    </div>
  )
}